<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
       version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 69943 54614"
       xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <path class="fil0"
        d="M3712 49600c-257,-2647 2671,-2061 4739,-2126 2244,-71 4567,70 6810,0 4493,-142 9126,142 13620,0 4493,-142 9126,142 13619,0l10225 -3c1154,12 1845,442 2047,1470 497,2529 -2762,2088 -4782,2062 -13416,-177 -27453,177 -40857,0 -1818,-24 -5244,437 -5421,-1403zm1754 -34029l26713 -1 1 14452 -26726 -69 12 -14382zm50719 18723c-3715,465 -6345,485 -9687,-778 -5321,-2012 -9031,-6334 -10524,-11603 -1051,-3709 -607,-5998 82,-9583l-27605 0c-3265,3 -6310,-892 -6325,2705 -16,4098 -295,35212 256,36379 565,1196 1870,1065 3516,1065l41198 0c9472,-2 9070,672 9107,-4582l-18 -13603z" />
   <path class="fil1"
         d="M51841 6693l6766 73c-937,1597 -1984,3166 -2950,4747l-3007 4902 6752 1 -9253 13350 2637 -10164 -5223 36 4278 -12945zm-800 -4487c-10594,1105 -17003,12265 -11755,22513 2505,4892 8691,8526 15075,7779 7786,-912 14395,-7918 13419,-16854 -853,-7820 -7902,-14360 -16739,-13438z" />
   <path class="fil0"
         d="M56185 34294l18 13603c-37,5254 365,4580 -9107,4582l-41198 0c-1646,0 -2951,131 -3516,-1065 -551,-1167 -272,-32281 -256,-36379 15,-3597 3060,-2702 6325,-2705l27605 0c-689,3585 -1133,5874 -82,9583 1493,5269 5203,9591 10524,11603 3342,1263 5972,1243 9687,778z" />
   <path class="fil0"
         d="M51041 2206c8837,-922 15886,5618 16739,13438 976,8936 -5633,15942 -13419,16854 -6384,747 -12570,-2887 -15075,-7779 -5248,-10248 1161,-21408 11755,-22513z" />
   <path class="fil2"
         d="M53568 54540c5388,37 4765,-4387 4765,-8004 0,-4256 0,-8513 0,-12768 3063,-1622 2818,-893 5918,-3616 1434,-1259 2175,-2130 3180,-3799 802,-1333 1207,-2276 1735,-3884 962,-2930 1046,-6635 162,-9742 -392,-1378 -942,-2762 -1598,-3849 -721,-1194 -1408,-2286 -2372,-3245 -4387,-4364 -9577,-6575 -16237,-5252 -3077,612 -5166,1808 -7474,3592 -1621,1254 -4332,4444 -4765,6301 -7377,0 -14754,0 -22132,0 -3388,0 -7802,-249 -11063,2 -4213,323 -3577,5098 -3577,7488 0,7378 0,14755 0,22132 0,3390 -248,7800 2,11064 116,1511 1225,2733 2378,3240 1986,875 9295,44 51078,340z" />
   <path class="fil0" d="M7622 54537l148 0 -148 0c50,0 99,0 148,0 0,0 0,0 0,0l-148 0z" />
   <path class="fil1"
         d="M49990 51003c2020,26 5279,467 4782,-2062 -202,-1028 -893,-1458 -2047,-1470l-10225 3c-4493,142 -9126,-142 -13619,0 -4494,142 -9127,-142 -13620,0 -2243,70 -4566,-71 -6810,0 -2068,65 -4996,-521 -4739,2126 177,1840 3603,1379 5421,1403 13404,177 27441,-177 40857,0z" />
   <path class="fil0"
         d="M47563 19638l5223 -36 -2637 10164 9253 -13350 -6752 -1 3007 -4902c966,-1581 2013,-3150 2950,-4747l-6766 -73 -4278 12945z" />
   <polygon class="fil1 str0" points="5454,29953 32180,30022 32179,15570 5466,15571 " />
   <path class="fil1"
         d="M51846 6755l6727 73c-932,1588 -1973,3148 -2933,4719l-2989 4874 6711 1 -9198 13271 2621 -10104 -5191 35 4252 -12869zm-796 -4460c-10531,1099 -16902,12193 -11684,22380 2490,4864 8639,8476 14986,7733 7740,-905 14309,-7870 13339,-16754 -848,-7774 -7855,-14276 -16641,-13359z" />
   <path class="fil2"
         d="M47594 19624l5191 -35 -2621 10104 9198 -13271 -6711 -1 2989 -4874c960,-1571 2001,-3131 2933,-4719l-6727 -73 -4252 12869z" />
 </g>
</svg>
</template>

<script>
export default {
  name: 'FVEInverter',
};
</script>

<style scoped>
.str0 {
  stroke: #FEFEFE;
  stroke-width: 413.746
}

.fil1 {
  fill: #FEFEFE
}

.fil2 {
  fill: #83C354
}

.fil0 {
  fill: #89EDE6
}
</style>
